/* ==========================================================================
   DEV - UPSELL
   ========================================================================== */

(function () {
  'use strict';

  var UPSELL_FLAG = 'tfpj:upsellShown';
  var ready = false;

  // Racine des routes Shopify (gère les préfixes de locale/marché, ex. /fr-ca/)
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Les ajouts sur la page panier ne déclenchent aucune modale
  function onCartPage() {
    return window.location.pathname.indexOf(cartRoot() + 'cart') === 0;
  }

  // Câble les flèches d'un slider .upsell__slider (modale ET suggestions panier).
  // Le scroll est 100 % CSS ; les flèches ne font qu'un scrollBy.
  function initSlider(slider) {
    if (!slider) return null;
    var track = slider.querySelector('.upsell__track');
    var prev = slider.querySelector('[data-upsell-prev]');
    var next = slider.querySelector('[data-upsell-next]');
    if (!track || !prev || !next) return null;

    function scrollStep() {
      return Math.round(track.clientWidth * 0.8);
    }
    function updateNav() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    return { updateNav: updateNav };
  }

  function init() {
    if (ready) return;

    var dialog = document.getElementById('upsell-popup');
    var confirmDialog = document.getElementById('upsell-confirm');
    // Au moins un des deux dialogs doit exister pour armer le flux d'ajout
    if (!dialog && !confirmDialog) return;
    ready = true;

    // Slider de la modale (les autres .upsell__slider sont câblés plus bas)
    var modalSlider = dialog ? initSlider(dialog.querySelector('.upsell__slider')) : null;

    /* ---- Ouverture / fermeture --------------------------------------- */

    function openUpsell() {
      if (!dialog || dialog.open) return;
      dialog.showModal(); // overlay, Échap, focus trap et scroll lock : natifs
      if (modalSlider) modalSlider.updateNav();
    }

    function openConfirm() {
      if (!confirmDialog || confirmDialog.open) return;
      confirmDialog.showModal();
    }

    // Logique unique : upsell au tout 1er ajout de la session, sinon confirmation
    function handleCartAdded() {
      if (onCartPage()) return;
      if (dialog && !sessionStorage.getItem(UPSELL_FLAG)) {
        sessionStorage.setItem(UPSELL_FLAG, '1');
        openUpsell();
      } else {
        openConfirm();
      }
    }

    // Clic hors modale (::backdrop cible le <dialog>) + boutons de fermeture,
    // pour l'upsell comme pour la confirmation
    [dialog, confirmDialog].forEach(function (d) {
      if (!d) return;
      d.addEventListener('click', function (e) {
        if (e.target === d) d.close();
      });
      d.querySelectorAll('[data-upsell-close], [data-confirm-continue]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          d.close();
        });
      });
    });

    /* ---- Flèches des sliders hors modale (ex. suggestions du panier) --- */

    document.querySelectorAll('.upsell__slider').forEach(function (slider) {
      if (dialog && dialog.contains(slider)) return; // déjà câblé (modale)
      initSlider(slider);
    });

    /* ---- Interception de l'ajout au panier du produit principal ------- */
    // Sur la page panier, on n'intercepte rien : les ajouts du bloc de
    // suggestions doivent suivre leur soumission classique (rechargement).

    if (!onCartPage()) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        if (form.closest('#upsell-popup')) return; // on ignore la modale elle-même
        if (form.closest('product-form')) return; // géré par le store → event tfpj:cart-added

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.disabled = true;

          fetch(cartRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          })
            .then(function (res) {
              if (!res.ok) throw new Error('cart/add failed');
              return res.json();
            })
            .then(function () {
              handleCartAdded();
            })
            .catch(function (err) {
              console.error('[upsell]', err);
              form.submit(); // repli : soumission classique
            })
            .finally(function () {
              if (submitBtn) submitBtn.disabled = false;
            });
        });
      });
    }

    /* ---- Ajout via <product-form> + store (listes / cartes / quick-shop) --- */

    document.addEventListener('tfpj:cart-added', handleCartAdded);

    /* ---- Ajout d'un produit d'upsell --------------------------------- */

    if (dialog) {
      dialog.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = parseInt(btn.dataset.variantId, 10);
          if (!id) return;

          btn.disabled = true;
          btn.classList.add('is-loading');

          fetch(cartRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('cart/add failed');
              window.location.href = cartRoot() + 'cart';
            })
            .catch(function (err) {
              console.error('[upsell]', err);
              btn.disabled = false;
              btn.classList.remove('is-loading');
            });
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
